import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
// import { Table } from "ant-table-extensions";
import { Table } from "antd";
import Grid from "@mui/system/Unstable_Grid/Grid";
import refreshBtn from "../../assets/images/refresh_btn.png";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { Modal } from "react-bootstrap";
import { CSVLink, CSVDownload } from "react-csv";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate } from "react-router-dom";
import Index from "../Quickfilter/index";
import "./style.css";
import {
  TextField,
  Box,
  Grid as MuiGrid,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import Swal from "sweetalert2";
import SoftSnackbar from "components/SoftSnackbar";
import styled from "@emotion/styled";
import imga1 from "../../assets/images/imga1.png";
import imga2 from "../../assets/images/imga2.png";
import imga3 from "../../assets/images/imga3.png";
import imga4 from "../../assets/images/imga4.png";
import imga5 from "../../assets/images/imga5.png";
import imga6 from "../../assets/images/peoples.png";
import AddIcon from "@mui/icons-material/Add";
import noDataImg from "../../../src/assets/images/browser.png";
import info from "../../assets/images/Group 1000004191.png";
import SideDrawer from "./SideDrawer";
const copy = require("clipboard-copy");

export const colGuidelines = [
  {
    title: "Column Name",
    dataIndex: "col_name",
    width: 200,
  },
  {
    title: "Sample Entry",
    dataIndex: "sample",
    width: 200,
  },
  {
    title: "Guide",
    // dataIndex: "guide",
    width: 300,
    render: (text) => (
      <>
        {text.guide === " - " ? (
          <p style={{ display: "flex", justifyContent: "center" }}>{text.guide}</p>
        ) : (
          <p style={{ display: "flex", justifyContent: "center" }}>{text.guide}</p>
        )}
      </>
    ),
  },
  {
    title: "Link",
    // dataIndex: "link",
    width: 500,
    render: (text) => (
      <>
        {text.link === " - " ? (
          <p style={{ display: "flex", justifyContent: "center" }}>{text.link}</p>
        ) : (
          <a href={text.link}>{text.link}</a>
        )}
      </>
    ),
    // render: (text) => {
    //   <>{text.link !== " - " ? <a href={text.link}>{text.link}</a> : " - "}</>;
    // },
  },
];

export const GuideData = [
  {
    col_name: "Mobile Number",
    sample: "9859859855",
    guide:
      "Please set the column cell for mobile number as Text format. Click on the link to know how to do this setting",
    link: "https://support.microsoft.com/en-us/office/format-numbers-as-text-583160db-936b-4e52-bdff-6f1863518ba4",
  },
  {
    col_name: "Date of birth",
    sample: "11-05-1996",
    guide:
      "Please set the column cell for date of birth in DD-MM-YYYY format . Click on the link to know how to do this setting",
    link: "https://support.microsoft.com/en-us/office/format-a-date-the-way-you-want-8e10019e-d5d8-47a1-ba95-db95123d273e",
  },
  {
    col_name: "First Name",
    sample: "Ramesh",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Last Name",
    sample: "Pawar",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Email",
    sample: "ramesh@gmail.com",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Gender",
    sample: "Male",
    guide: "Please enter from options (Male,Female,Others)",
    link: " - ",
  },
  {
    col_name: "State",
    sample: "Maharashtra",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "District",
    sample: "Mumbai",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Taluka",
    sample: "Andheri",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Current Salary",
    sample: "10000-15000",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Desired Salary",
    sample: "15000-20000",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Experience",
    sample: "0-1",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Job Role",
    sample: "Waiter",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Industry",
    sample: "Hospitality and Management",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Language",
    sample: "Hindi",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Degree",
    sample: "Bachelors of Ed",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Highest Education",
    sample: "HSC",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Stream",
    sample: "Commerce",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Skills",
    sample: "Communications",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Resume Link",
    sample: "Enter link of resume",
    guide: " - ",
    link: " - ",
  },
  // {
  //   col_name: "Language",
  //   sample: "Hindi",
  //   guide: " - ",
  //   link: " - ",
  // },
];

const CandidatesList = () => {
  // var fileSaver = require("file-saver");
  const matchsm = useMediaQuery("(max-width:768.5px)");
  const [copiedLink, setCopiedLink] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const cpId = sessionStorage.getItem("register_id");
  const [name, setName] = useState("");
  const [resumeModal, setResumeModal] = useState(false);
  const [resumefile, setResumeFile] = useState("");
  const [rowData, setRowData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [orgId, setOrgId] = useState(searchParams.get("orgid"));
  const [jobId, setJobId] = useState(searchParams.get("jobid"));
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadedOption, setUploadOption] = useState(false);
  const [instructionModal, setInstructionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [CSVFile, setCSVFile] = useState("");
  const [canId, setCanId] = useState("");
  const [time, setTime] = useState([]);
  const [candData, setCandData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [timelineLoading, setTimeLineLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [filteroff, setFilteroff] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [statefilter, setStatefilter] = useState("");
  const [districtfilter, setDistrictfilter] = useState("");
  const [datefilter, setDatefilter] = useState([]);
  const [jffilter, setJffilter] = useState("");
  const [educationfilter, setEducationfilter] = useState("");
  const [rolefilter, setRolefilter] = useState("");
  const [degreefilter, setDegreefilter] = useState("");
  const [boardingfilter, setBoardingfilter] = useState([18, 45]);
  const [table, setTable] = useState(0);
  const [tableshow, setTableshow] = useState(0);
  const [allData, setAllData] = useState(true);
  const [veridetails, setVeridetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    date_of_birth: "",
    highest_education: "",
    current_salary: "",
    experience: "",
    job_role: "",
    dataSource: "",
    state: "",
    skills: "",
    taluka: "",
    district: "",
    lastactive: "",
    modified: "",
    registration_id: "",
    stream: "",
    current_industry: "",
    desired_salary: "",
    languages: "",
    self_opportunity: "",
    avl_skill: "",
    gender: "",
    marital_status: "",
    mobnum: "",
    address: "",
    wa_optin: "",
    resume: "",
    pincode: "",
    datasource: "",
    createddt: "",
  });
  var fileSaver = require("file-saver");
  const [KPIObj, setKPIObj] = useState({
    candidate_upload_count: "0",
    job_accepted_count: "0",
    job_assigned_count: "0",
    pipeline_count: "0",
    placed_count: "0",
    expectedCost: "0",
    actualCost: "0",
    formLink: "",
    qrLink: "",
  });

  const toggleSnackbar = () => setShowSnackbar(!showSnackbar);

  const ST1 = styled(Typography)({
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#6C6C6C",
  });

  const ST2 = styled(Typography)({
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#FF8000",
  });

  const ST3 = styled(Typography)({
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#3B5092",
  });

  const ST4 = styled(Typography)({
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#000000",
  });

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      fontFamily: "Poppins",
      width: "250px",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
  };

  const HandleTimeline = () => {
    setTimeLineLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/counsellor/associate/fetch/timeline`, {
        params: {
          candidate_id: candData?.registration_id,
          orgid: orgId,
          jobid: jobId,
        },
      })
      .then((res) => {
        setTimeLineLoading(false);
        setTime(res?.data?.timeline_details);
      })
      .catch((err) => {
        console.log(err);
        setTimeLineLoading(false);
      });
  };

  useEffect(() => {
    HandleTimeline();
  }, [candData]);

  const HandleFetchCandDetails = async (value) => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/jobseeker/register`, {
        params: { reg_id: value },
      })
      .then((res) => {
        setCandData(res.data.JobSeeker_List);
        setOpenModal(true);
        setVeridetails({
          first_name: res.data.JobSeeker_List.first_name,
          last_name: res.data.JobSeeker_List.last_name,
          email: res.data.JobSeeker_List.email,
          mobile: res.data.JobSeeker_List.mobile,
          date_of_birth:
            res.data.JobSeeker_List.date_of_birth !== null
              ? moment(res.data.JobSeeker_List.date_of_birth).format("YYYY-MM-DD")
              : null,
          highest_education: res.data.JobSeeker_List.highest_education,
          current_salary: res.data.JobSeeker_List.current_salary,
          experience: res.data.JobSeeker_List.experience,
          job_role: res.data.JobSeeker_List.job_role,
          dataSource: res.data.JobSeeker_List.datasource,
          state: res.data.JobSeeker_List.state,
          skills: res.data.JobSeeker_List.skills,
          taluka: res.data.JobSeeker_List.taluka,
          district: res.data.JobSeeker_List.district,
          lastactive: moment(res.data.JobSeeker_List.last_activedate).format("DD-MM-YYYY"),
          modified: moment(res.data.JobSeeker_List.last_modified_dt).format("DD-MM-YYYY"),
          notes:
            res.data.JobSeeker_List.notes === "" ||
            res.data.JobSeeker_List.notes === "nan" ||
            res.data.JobSeeker_List.notes === null
              ? ""
              : res.data.JobSeeker_List?.notes,
        });
        console.log(res?.data?.JobSeeker_List, "poison");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleFetchorg = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/dropdown/org`,
        {
          params: {
            cp_id: cpId,
            job_type: tableshow === 3 ? "Internship" : "",
            // counsellor_id: sessionStorage.getItem("cons_id"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        setOrgList(res?.data["Organisation Name"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDynamicSearch = async () => {
    setIsLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/dynamic/search`,
        {
          search_data: name,
          limit: pageSize,
          offset: paginationState.page - 1,
          cpid: cpId,
          jobid: jobId,
          job_type: tableshow === 3 ? "Internship" : "",
        }
      )
      .then((res) => {
        setSearchData(
          res.data["search_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education:
              ele.highest_education === "nan" ||
              ele.highest_education === "" ||
              ele.highest_education === null
                ? ""
                : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback: ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.candidate_status ? ele.candidate_status : "Bot yet to engage",
            display_comment: ele.display_comment,
          }))
        );
        Setadmindata(
          res.data["search_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education: ele.highest_education === "nan" ? "" : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback: ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.candidate_status ? ele.candidate_status : "Bot yet to engage",
            display_comment: ele.display_comment,
          }))
        );
        setPaginationState({ ...paginationState, dataSize: res.data["count"] });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleFetchjob = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/dropdown/org`,
        {
          params: {
            cp_id: cpId,
            org_id: orgId,
            job_type: tableshow === 3 ? "Internship" : "",
            // counsellor_id: sessionStorage.getItem("cons_id"),
          },
        }
      )
      .then((res) => {
        console.log(res, "joblist");
        setJobList(res?.data["Jobpost Name"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleKPIs = async () => {
    setFetching(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/kpi`, {
        params: {
          cpid: cpId,
          orgid: orgId,
          jobid: jobId,
        },
      })
      .then((res) => {
        setFetching(false);
        setKPIObj({
          candidate_upload_count: res.data["Candidate KPI"].candidate_upload_count,
          job_accepted_count: res.data["Candidate KPI"].job_accepted_count,
          job_assigned_count: res.data["Candidate KPI"].job_assigned_count,
          pipeline_count: res.data["Candidate KPI"].pipeline_count,
          placed_count: res.data["Candidate KPI"].placed_count,
          expectedCost: res.data["Candidate KPI"].expected
            ? res.data["Candidate KPI"].expected
            : "0",
          actualCost: res.data["Candidate KPI"].actual ? res.data["Candidate KPI"].actual : "0",
          formLink: res.data["Candidate KPI"].form_link,
          qrLink: res.data["Candidate KPI"].qr_code,
        });
      })
      .catch((err) => {
        setFetching(false);
      });
  };

  const fetchTable1 = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/self_employement`,
        {
          params: {
            cpid: cpId,
          },
        }
      );
      const data = await res.data;
      setTable1(
        data?.map((ele, id) => ({
          registration_id: ele.registration_id,
          first_name: ele.firstname,
          last_name: ele.lastname,
          candidate: `${ele.firstname} ${ele.lastname}`,
          date_of_birth: moment(ele.date_of_birth).format("DD-MM-YYYY"),
          mobile: ele?.mobnum?.length === 12 ? ele?.mobnum?.substring(2) : ele.mobnum,
          email: ele.email,
          gender: ele.gender,
          state: ele.state,
          district: ele.district,
          taluka: ele.taluka,
          highest_education: ele.highest_education,
          degree: ele.degree,
          stream: ele.stream,
          experience: ele.experience,
          current_salary: ele.current_salary,
          desired_salary: ele.desired_salary,
          job_role: ele.job_role,
          industry: ele.industry,
          marital_status: ele.marital_status,
          skills: ele.skills,
          part_time: ele.part_time,
          specially_abled: ele.specially_abled,
          job_priority: ele.job_priority,
          resume_cv: ele.resume_cv,
          last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
          last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
          data_status_type: ele.data_status_type,
          wa_optin: ele.wa_optin,
          datasource: ele.datasource,
          createddt: moment(ele.createddt).format("DD-MM-YYYY"),
          modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
          ///////// stages data////////
          feedback: ele.feedback,
          sent_status: ele.sent_status,
          broadcast_status: ele.broadcast_status,
          ratings: ele.ratings,
          stage: ele.stage,
          completion_status: ele.completion_status,
          candidate_status: ele.candidate_status,
          display_comment: ele.display_comment,
        }))
      );
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTable2 = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/skilling`,
        {
          params: {
            cpid: cpId,
          },
        }
      );
      const data = await res.data;
      console.log(data, "table2");
      setTable2(
        data?.map((ele, id) => ({
          registration_id: ele.registration_id,
          first_name: ele.firstname,
          last_name: ele.lastname,
          candidate: `${ele.firstname} ${ele.lastname}`,
          date_of_birth: moment(ele.date_of_birth).format("DD-MM-YYYY"),
          mobile: ele?.mobnum?.length === 12 ? ele?.mobnum?.substring(2) : ele.mobnum,
          email: ele.email,
          gender: ele.gender,
          state: ele.state,
          district: ele.district,
          taluka: ele.taluka,
          highest_education: ele.highest_education,
          degree: ele.degree,
          stream: ele.stream,
          experience: ele.experience,
          current_salary: ele.current_salary,
          desired_salary: ele.desired_salary,
          job_role: ele.job_role,
          industry: ele.industry,
          marital_status: ele.marital_status,
          skills: ele.skills,
          part_time: ele.part_time,
          specially_abled: ele.specially_abled,
          job_priority: ele.job_priority,
          resume_cv: ele.resume_cv,
          last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
          last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
          data_status_type: ele.data_status_type,
          wa_optin: ele.wa_optin,
          datasource: ele.datasource,
          createddt: moment(ele.createddt).format("DD-MM-YYYY"),
          modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
          ///////// stages data////////
          feedback: ele.feedback,
          sent_status: ele.sent_status,
          broadcast_status: ele.broadcast_status,
          ratings: ele.ratings,
          stage: ele.stage,
          completion_status: ele.completion_status,
          candidate_status: ele.candidate_status,
          display_comment: ele.display_comment,
        }))
      );
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setOrgId("");
    handleFetchorg();
    setJobId("");
    setPaginationState({ page: 1, dataSize: "" });
    setName("");
    tableshow === 1 && fetchTable1();
    tableshow === 2 && fetchTable2();
    tableshow === 3 && fetchCandidates();
    tableshow === 0 && fetchCandidates();
  }, [tableshow]);

  const ResumeUploadFunc = async (data) => {
    console.log("resume row:", data);
    let docData = new FormData();
    docData.append("jsid", data.key);
    docData.append("type", "resume");
    docData.append("resume", resumefile);
    // docData.append("updatedby", registerID);
    await axios
      .patch(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/jobseeker/register`,
        docData
      )
      .then((res) => {
        console.log("upload", res);
        Swal.fire({
          icon: "success",
          title: "",
          text: res?.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        }).then(() => setResumeModal(false));
      })
      .catch((err) => {
        console.log("upload", err);
        Swal.fire({
          icon: "error",
          title: err?.data["Developer Message"] ? err?.data["Developer Message"] : "Oops...",
          text: err?.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  const colName = [
    {
      title: "Upload Date",
      //dataIndex: "candidate_date",
      key: "created_date",
      width: 200,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.created_date - b?.created_date,
        multiple: 1,
      },
      render: (text) => <>{text.created_date === "" ? "-" : text.created_date}</>,
    },
    {
      title: "Candidate Name",
      //dataIndex: "candidate",
      width: 200,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
      render: (text, record) => (
        <p
          onClick={() => {
            setCanId(record.key);
            HandleFetchCandDetails(record.key);
          }}
          style={{
            cursor: "pointer",
            marginBottom: "-2px",
            color: "#3B5092",
            textDecorationLine: "underline",
          }}
        >
          {/* {`${text.first_name}` + " " + `${text.last_name}`} */}
          {`${text.candidate}`}
        </p>
      ),
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    {
      title: "Email",
      //dataIndex: "taluka",
      key: "email",
      width: 250,
      sorter: {
        compare: (a, b) => a?.email?.localeCompare(b?.email),
        multiple: 7,
      },
      render: (text) => <>{text.email === "" ? "-" : text.email}</>,
    },
    /*
    {
      title: "Education",
      //dataIndex: "highest_education",
      key: "education",
      width: 200,
      sorter: {
        compare: (a, b) => a?.highest_education?.localeCompare(b?.highest_education),
        multiple: 3,
      },
      render: (text) => <>{text.highest_education === "" ? "-" : text.highest_education}</>,
    },
    {
      title: "Degree",
      //dataIndex: "highest_education",
      key: "degree",
      width: 200,
      sorter: {
        compare: (a, b) => a?.degree?.localeCompare(b?.degree),
        multiple: 3,
      },
      render: (text) => <>{text.degree === "" ? "-" : text.degree}</>,
    },
    {
      title: "Stream",
      //dataIndex: "highest_education",
      key: "stream",
      width: 200,
      sorter: {
        compare: (a, b) => a?.stream?.localeCompare(b?.stream),
        multiple: 3,
      },
      render: (text) => <>{text.stream === "" ? "-" : text.stream}</>,
    },
    {
      title: "Industry",
      //dataIndex: "highest_education",
      key: "industry",
      width: 300,
      sorter: {
        compare: (a, b) => a?.industry?.localeCompare(b?.industry),
        multiple: 3,
      },
      render: (text) => <>{text.industry === "" ? "-" : text.industry}</>,
    },
    {
      title: "Role",
      //dataIndex: "job_role",
      key: "role",
      width: 400,
      sorter: {
        compare: (a, b) => a?.job_role?.localeCompare(b?.job_role),
        multiple: 4,
      },
      render: (text) => <>{text.job_role === "" ? "-" : text.job_role}</>,
    },
    {
      title: "Skills",
      //dataIndex: "skills",
      key: "skills",
      width: 200,
      sorter: {
        compare: (a, b) => a?.skills?.localeCompare(b?.skills),
        multiple: 5,
      },
      render: (text) => <>{text.skills === "" ? "-" : text.skills}</>,
    },
    {
      title: "Age",
      //dataIndex: "state",
      key: "age",
      width: 200,
      sorter: {
        compare: (a, b) => a?.age - b?.age,
        multiple: 6,
      },
      render: (text) => (
        <>
          {text.age !== 0 ? text.age : " - "}
        </>
      ),
    },
    */
    {
      title: "Gender",
      //dataIndex: "state",
      key: "gender",
      width: 200,
      sorter: {
        compare: (a, b) => a?.gender?.localeCompare(b?.gender),
        multiple: 6,
      },
      render: (text) => <>{text.gender === "" ? "-" : text.gender}</>,
    },
    // {
    //   title: "Marital Status",
    //   //dataIndex: "state",
    //   width: 200,
    //   sorter: {
    //     compare: (a, b) => a?.marital_status?.localeCompare(b?.marital_status),
    //     multiple: 6,
    //   },
    //   render: (text) => <>{text.marital_status === "" ? "-" : text.marital_status}</>,
    // },
    // {
    //   title: "Languages",
    //   //dataIndex: "state",
    //   width: 200,
    //   sorter: {
    //     compare: (a, b) => a?.languages?.localeCompare(b?.languages),
    //     multiple: 6,
    //   },
    //   render: (text) => <>{text.languages === "" ? "-" : text.languages}</>,
    // },
    {
      title: "State",
      //dataIndex: "state",
      key: "state",
      width: 200,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
      render: (text) => <>{text.state === "" ? "-" : text.state}</>,
    },
    {
      title: "District",
      //dataIndex: "district",
      key: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
      render: (text) => <>{text.district === "" ? "-" : text.district}</>,
    },
    /*
    {
      title: "Taluka",
      //dataIndex: "taluka",
      key: "taluka",
      width: 150,
      sorter: {
        compare: (a, b) => a?.taluka?.localeCompare(b?.taluka),
        multiple: 7,
      },
      render: (text) => <>{text.taluka === "" ? "-" : text.taluka}</>,
    },
    */
    {
      title: "Application Stage",
      // dataIndex: "stages",
      key: "stage",
      // sorter: { compare: (a, b) => a.stages - b.stages },
      width: 250,
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* {round.map((ele, i) => ( */}
          <Tooltip title="Bot sucecessfully engaged" placement="bottom">
            <div
              // key={i + 1}
              className={
                text.stage === 0 && text.completion_status === "completed"
                  ? "completed-class"
                  : text.stage > 0
                  ? "completed-class"
                  : text.stage === "" &&
                    text.completion_status === "in_progress" &&
                    text.candidate_status !== "Bot yet to engage"
                  ? "in_progress-class"
                  : text.stage === 0 &&
                    text.completion_status === "in_progress" &&
                    text.candidate_status !== "Bot yet to engage"
                  ? "in_progress-class"
                  : text.stage === "" && text.completion_status === "rejected"
                  ? "rejected-class"
                  : text.stage === "" &&
                    text.completion_status === "in_progress" &&
                    text.candidate_status === "Bot yet to engage"
                  ? "default"
                  : text.stage === 0 &&
                    text.completion_status === "in_progress" &&
                    text.candidate_status === "Bot yet to engage"
                  ? "default"
                  : "default"
              }
              // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
            ></div>
          </Tooltip>
          {/* ))} */}
          <Tooltip title="Counsellor Engagement on" placement="bottom">
            <div
              // key={i + 1}
              className={
                text.stage === 0 && text.completion_status === "completed"
                  ? "in_progress-class"
                  : text.stage === 1 && text.completion_status === "completed"
                  ? "completed-class"
                  : text.stage === 0 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : text.stage === 1 && text.completion_status === "rejected"
                  ? "completed-class"
                  : text.stage === 1 && text.completion_status === "in_progress"
                  ? "completed-class"
                  : text.stage > 1
                  ? "completed-class"
                  : // : text.stage === 0 && text.completion_status === "in_progress"
                  // ? "in_progress-class"
                  text.stage === 1 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : "default"
              }
              // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
            ></div>
          </Tooltip>
          <Tooltip title="Interview Process Initiated" placement="bottom">
            <div
              // key={i + 1}
              className={
                text.stage === 1 && text.completion_status === "completed"
                  ? "in_progress-class"
                  : text.stage === 2 && text.completion_status === "completed"
                  ? "completed-class"
                  : text.stage === 1 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : text.stage === 2 && text.completion_status === "rejected"
                  ? "completed-class"
                  : text.stage === 2 && text.completion_status === "in_progress"
                  ? "completed-class"
                  : text.stage > 2
                  ? "completed-class"
                  : text.stage === 1 && text.completion_status === "in_progress"
                  ? "in_progress-class"
                  : text.stage === 2 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : "default"
              }
              // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
            ></div>
          </Tooltip>
          <Tooltip title="Interview Process On" placement="bottom">
            <div
              // key={i + 1}
              className={
                text.stage === 2 && text.completion_status === "completed"
                  ? "in_progress-class"
                  : text.stage === 3 && text.completion_status === "completed"
                  ? "completed-class"
                  : text.stage === 2 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : text.stage === 3 && text.completion_status === "rejected"
                  ? "completed-class"
                  : text.stage === 3 && text.completion_status === "in_progress"
                  ? "completed-class"
                  : text.stage > 3
                  ? "completed-class"
                  : text.stage === 2 && text.completion_status === "in_progress"
                  ? "in_progress-class"
                  : text.stage === 3 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : "default"
              }
              // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
            ></div>
          </Tooltip>
          <Tooltip title="Final Selection Stage" placement="bottom">
            <div
              // key={i + 1}
              className={
                text.stage === 3 && text.completion_status === "completed"
                  ? "in_progress-class"
                  : text.stage === 4 && text.completion_status === "completed"
                  ? "completed-class"
                  : text.stage === 3 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : text.stage === 4 && text.completion_status === "rejected"
                  ? "completed-class"
                  : text.stage === 4 && text.completion_status === "in_progress"
                  ? "completed-class"
                  : text.stage > 4
                  ? "completed-class"
                  : text.stage === 3 && text.completion_status === "in_progress"
                  ? "in_progress-class"
                  : text.stage === 4 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : "default"
              }
              // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
            ></div>
          </Tooltip>
          <Tooltip title="Post Selection Stage" placement="bottom">
            <div
              // key={i + 1}
              className={
                text.stage === 4 && text.completion_status === "completed"
                  ? "in_progress-class"
                  : text.stage === 5 && text.completion_status === "completed"
                  ? "completed-class"
                  : text.stage === 4 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : text.stage === 5 && text.completion_status === "rejected"
                  ? "completed-class"
                  : text.stage === 5 && text.completion_status === "in_progress"
                  ? "completed-class"
                  : text.stage > 5
                  ? "completed-class"
                  : text.stage === 4 && text.completion_status === "in_progress"
                  ? "in_progress-class"
                  : text.stage === 5 && text.completion_status === "rejected"
                  ? "rejected-class"
                  : "default"
              }
              // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
            ></div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Status",
      //   dataIndex: "status",
      //   sorter: {
      //     compare: (a, b) => a?.status?.localeCompare(b?.status),
      //     multiple: 8,
      //   },
      key: "candidate_status",
      width: 300,
      // render: (text) => (
      //   <SoftBox
      //     sx={{
      //       display: "inline-flex",
      //       padding: "5px 8px",
      //       alignItems: "flex-start",
      //       gap: "10px",
      //       borderRadius: "10px",
      //       backgroundColor:
      //         text.status === "true" ? "#B7F4BB" : text.status === "false" ? "#FFD2D2" : "#FFD2A5",
      //     }}
      //   >
      //     <SoftTypography
      //       sx={{
      //         color:
      //           text.status === "true"
      //             ? "#049C2F"
      //             : text.status === "false"
      //             ? "#FF0000"
      //             : "#EA7500",
      //         fontSize: "12px",
      //         fontWeight: "small",
      //       }}
      //     >
      //       {text.status === "true"
      //         ? "Placed"
      //         : text.status === "false"
      //         ? "Not Placed"
      //         : "In Pipeline"}
      //     </SoftTypography>
      //   </SoftBox>
      // ),
      render: (text) => (
        <span
          style={{
            backgroundColor:
              text.completion_status === "completed"
                ? "#BDFDC8"
                : text.completion_status === "rejected"
                ? "#EFD6FF"
                : "#FFE1C3",
            color:
              text.completion_status === "completed"
                ? "#049C2F"
                : text.completion_status === "rejected"
                ? "#62049C"
                : "#EA7500",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "50px",
          }}
        >
          {text.candidate_status}
        </span>
      ),
    },
    /*
    {
      title: "Data Source",
      dataIndex: "datasource",
      key: "datasource",
      width: 200,
      sorter: {
        compare: (a, b) => a?.datasource?.localeCompare(b?.datasource),
        multiple: 6,
      },
    },
    */
    {
      title: "Counsellor Comments",
      // dataIndex: "comments",
      width: 200,
      key: "display_comment",
      sorter: { compare: (a, b) => a?.display_comment?.localeCompare(b?.display_comment) },
      render: (text) => (
        <>{text.display_comment === "" ? "-" : text.display_comment}</>
        // <span>{text.job_role}</span>
      ),
    },
    /*
    {
      title: "Candidate Feedback",
      // dataIndex: "feedback",
      width: 200,
      key: "feedback",
      sorter: { compare: (a, b) => a?.feedback?.localeCompare(b?.feedback) },
      render: (text) => (
        <>{text.feedback === "" ? "-" : text.feedback}</>
        // <span>{text.job_role}</span>
      ),
    },
    {
      title: "Resume",
      width: 150,
      key: "resume_cv",
      render: (text) =>
        text?.resume_cv === undefined || text?.resume_cv === null || text?.resume_cv === "" ? (
          <span>
            <SoftBadge
              variant="contained"
              color="red"
              size="lg"
              badgeContent={"Unavailable"}
              container
            />
          </span>
        ) : (
          (console.log("a", text.resume_cv),
            (
              <a href={text.resume_cv} target="_blank" rel="noreferrer">
                <SoftBadge
                  variant="contained"
                  color="success"
                  size="lg"
                  badgeContent={"View"}
                  container
                />
              </a>
            ))
        ),
    },
    */
  ];

  const colName1 = [
    {
      title: "Candidate Name",
      dataIndex: "candidate",
      width: 200,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    {
      title: "Education",
      dataIndex: "highest_education",
      width: 200,
      sorter: {
        compare: (a, b) => a?.highest_education?.localeCompare(b?.highest_education),
        multiple: 3,
      },
    },
    {
      title: "Role",
      dataIndex: "job_role",
      width: 200,
      sorter: {
        compare: (a, b) => a?.job_role?.localeCompare(b?.job_role),
        multiple: 4,
      },
    },
    {
      title: "Skills",
      dataIndex: "skills",
      width: 200,
      sorter: {
        compare: (a, b) => a?.skills?.localeCompare(b?.skills),
        multiple: 5,
      },
    },
    {
      title: "State",
      dataIndex: "state",
      width: 200,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
    },
    {
      title: "District",
      dataIndex: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
    },
  ];

  const colName3 = [
    {
      title: "Upload Date",
      //dataIndex: "candidate_date",
      key: "created_date",
      width: 200,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.created_date - b?.created_date,
        multiple: 1,
      },
      render: (text) => <>{text.created_date === "" ? "-" : text.created_date}</>,
    },
    {
      title: "Candidate Name",
      //dataIndex: "candidate",
      width: 200,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
      render: (text, record) => (
        <p
          onClick={() => {
            setCanId(record.key);
            HandleFetchCandDetails(record.key);
          }}
          style={{
            cursor: "pointer",
            marginBottom: "-2px",
            color: "#3B5092",
            textDecorationLine: "underline",
          }}
        >
          {/* {`${text.first_name}` + " " + `${text.last_name}`} */}
          {`${text.candidate}`}
        </p>
      ),
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    {
      title: "Email",
      //dataIndex: "taluka",
      key: "email",
      width: 250,
      sorter: {
        compare: (a, b) => a?.email?.localeCompare(b?.email),
        multiple: 7,
      },
      render: (text) => <>{text.email === "" ? "-" : text.email}</>,
    },
    /*
    {
      title: "Education",
      //dataIndex: "highest_education",
      key: "education",
      width: 200,
      sorter: {
        compare: (a, b) => a?.highest_education?.localeCompare(b?.highest_education),
        multiple: 3,
      },
      render: (text) => <>{text.highest_education === "" ? "-" : text.highest_education}</>,
    },
    {
      title: "Degree",
      //dataIndex: "highest_education",
      key: "degree",
      width: 200,
      sorter: {
        compare: (a, b) => a?.degree?.localeCompare(b?.degree),
        multiple: 3,
      },
      render: (text) => <>{text.degree === "" ? "-" : text.degree}</>,
    },
    {
      title: "Stream",
      //dataIndex: "highest_education",
      key: "stream",
      width: 200,
      sorter: {
        compare: (a, b) => a?.stream?.localeCompare(b?.stream),
        multiple: 3,
      },
      render: (text) => <>{text.stream === "" ? "-" : text.stream}</>,
    },
    {
      title: "Industry",
      //dataIndex: "highest_education",
      key: "industry",
      width: 300,
      sorter: {
        compare: (a, b) => a?.industry?.localeCompare(b?.industry),
        multiple: 3,
      },
      render: (text) => <>{text.industry === "" ? "-" : text.industry}</>,
    },
    {
      title: "Role",
      //dataIndex: "job_role",
      key: "role",
      width: 400,
      sorter: {
        compare: (a, b) => a?.job_role?.localeCompare(b?.job_role),
        multiple: 4,
      },
      render: (text) => <>{text.job_role === "" ? "-" : text.job_role}</>,
    },
    {
      title: "Skills",
      //dataIndex: "skills",
      key: "skills",
      width: 200,
      sorter: {
        compare: (a, b) => a?.skills?.localeCompare(b?.skills),
        multiple: 5,
      },
      render: (text) => <>{text.skills === "" ? "-" : text.skills}</>,
    },
    {
      title: "Age",
      //dataIndex: "state",
      key: "age",
      width: 200,
      sorter: {
        compare: (a, b) => a?.age - b?.age,
        multiple: 6,
      },
      render: (text) => (
        <>
          {text.age !== 0 ? text.age : " - "}
        </>
      ),
    },
    */
    {
      title: "Gender",
      //dataIndex: "state",
      key: "gender",
      width: 200,
      sorter: {
        compare: (a, b) => a?.gender?.localeCompare(b?.gender),
        multiple: 6,
      },
      render: (text) => <>{text.gender === "" ? "-" : text.gender}</>,
    },
    // {
    //   title: "Marital Status",
    //   //dataIndex: "state",
    //   width: 200,
    //   sorter: {
    //     compare: (a, b) => a?.marital_status?.localeCompare(b?.marital_status),
    //     multiple: 6,
    //   },
    //   render: (text) => <>{text.marital_status === "" ? "-" : text.marital_status}</>,
    // },
    // {
    //   title: "Languages",
    //   //dataIndex: "state",
    //   width: 200,
    //   sorter: {
    //     compare: (a, b) => a?.languages?.localeCompare(b?.languages),
    //     multiple: 6,
    //   },
    //   render: (text) => <>{text.languages === "" ? "-" : text.languages}</>,
    // },
    {
      title: "State",
      //dataIndex: "state",
      key: "state",
      width: 200,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
      render: (text) => <>{text.state === "" ? "-" : text.state}</>,
    },
    {
      title: "District",
      //dataIndex: "district",
      key: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
      render: (text) => <>{text.district === "" ? "-" : text.district}</>,
    },
    /*
    {
      title: "Taluka",
      //dataIndex: "taluka",
      key: "taluka",
      width: 150,
      sorter: {
        compare: (a, b) => a?.taluka?.localeCompare(b?.taluka),
        multiple: 7,
      },
      render: (text) => <>{text.taluka === "" ? "-" : text.taluka}</>,
    },
    */

    {
      title: "Status",
      //   dataIndex: "status",
      //   sorter: {
      //     compare: (a, b) => a?.status?.localeCompare(b?.status),
      //     multiple: 8,
      //   },
      key: "candidate_status",
      width: 300,
      // render: (text) => (
      //   <SoftBox
      //     sx={{
      //       display: "inline-flex",
      //       padding: "5px 8px",
      //       alignItems: "flex-start",
      //       gap: "10px",
      //       borderRadius: "10px",
      //       backgroundColor:
      //         text.status === "true" ? "#B7F4BB" : text.status === "false" ? "#FFD2D2" : "#FFD2A5",
      //     }}
      //   >
      //     <SoftTypography
      //       sx={{
      //         color:
      //           text.status === "true"
      //             ? "#049C2F"
      //             : text.status === "false"
      //             ? "#FF0000"
      //             : "#EA7500",
      //         fontSize: "12px",
      //         fontWeight: "small",
      //       }}
      //     >
      //       {text.status === "true"
      //         ? "Placed"
      //         : text.status === "false"
      //         ? "Not Placed"
      //         : "In Pipeline"}
      //     </SoftTypography>
      //   </SoftBox>
      // ),
      render: (text) => (
        <span
          style={{
            backgroundColor:
              text.completion_status === "completed"
                ? "#BDFDC8"
                : text.completion_status === "rejected"
                ? "#EFD6FF"
                : "#FFE1C3",
            color:
              text.completion_status === "completed"
                ? "#049C2F"
                : text.completion_status === "rejected"
                ? "#62049C"
                : "#EA7500",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "50px",
          }}
        >
          {text.candidate_status}
        </span>
      ),
    },
    /*
    {
      title: "Data Source",
      dataIndex: "datasource",
      key: "datasource",
      width: 200,
      sorter: {
        compare: (a, b) => a?.datasource?.localeCompare(b?.datasource),
        multiple: 6,
      },
    },
    */

    /*
    {
      title: "Candidate Feedback",
      // dataIndex: "feedback",
      width: 200,
      key: "feedback",
      sorter: { compare: (a, b) => a?.feedback?.localeCompare(b?.feedback) },
      render: (text) => (
        <>{text.feedback === "" ? "-" : text.feedback}</>
        // <span>{text.job_role}</span>
      ),
    },
    {
      title: "Resume",
      width: 150,
      key: "resume_cv",
      render: (text) =>
        text?.resume_cv === undefined || text?.resume_cv === null || text?.resume_cv === "" ? (
          <span>
            <SoftBadge
              variant="contained"
              color="red"
              size="lg"
              badgeContent={"Unavailable"}
              container
            />
          </span>
        ) : (
          (console.log("a", text.resume_cv),
            (
              <a href={text.resume_cv} target="_blank" rel="noreferrer">
                <SoftBadge
                  variant="contained"
                  color="success"
                  size="lg"
                  badgeContent={"View"}
                  container
                />
              </a>
            ))
        ),
    },
    */
  ];

  const [colHeaders, setColHeaders] = useState([
    {
      label: "Upload Date",
      key: "created_date",
      isExportable: true,
    },
    {
      label: "Candidate Name",
      key: "candidate",
      isExportable: true,
    },
    {
      label: "Phone",
      key: "mobile",
      isExportable: true,
    },
    {
      label: "Email",
      key: "email",
      isExportable: true,
    },
    {
      label: "Education",
      key: "education",
      isExportable: true,
    },
    {
      label: "Degree",
      key: "degree",
      isExportable: true,
    },
    {
      label: "Stream",
      key: "stream",
      isExportable: true,
    },
    {
      label: "Industry",
      key: "industry",
      isExportable: true,
    },
    {
      label: "Role",
      key: "role",
      isExportable: true,
    },
    {
      label: "Skills",
      key: "skills",
      isExportable: true,
    },
    {
      label: "Age",
      key: "age",
      isExportable: true,
    },
    {
      label: "Gender",
      key: "gender",
      isExportable: true,
    },
    {
      label: "State",
      key: "state",
      isExportable: true,
    },
    {
      label: "District",
      key: "district",
      isExportable: true,
    },
    {
      label: "Taluka",
      key: "taluka",
      isExportable: true,
    },
    {
      label: "Status",
      key: "candidate_status",
      isExportable: true,
    },
    // {
    //   label: "Data Source",
    //   key: "datasource",
    //   isExportable: true,
    // },
    {
      label: "Counsellor Comments",
      key: "display_comment",
      isExportable: true,
    },
    {
      label: "Counsellor Feedbacks",
      key: "feedback",
      isExportable: true,
    },
    {
      label: "Resume",
      key: "resume_cv",
      isExportable: true,
    },
  ]);

  const handleClick = () => {
    if (tablerow.length !== 0) {
      setShow(!show);
      getFileName();
    } else {
      handleDownload();
    }
  };

  const handleDownload = async () => {
    setDownloadingModal(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/candidatesearch/downloadallcandidatedata`,
        {
          //responseType: 'arraybuffer',
          // shortlistedid: candidateIdsObj,
          // cpid: cpId,
          // orgid: orgId,
          // jobid: jobId,
          objid: sessionStorage.getItem("dow_id"),
          email: sessionStorage.getItem("email"),
        }
      );
      console.log(res.data, "xxx1");
      if (res.data) {
        setDownloadingModal(false);
      }
      // var blob = new Blob([res.data], { type: ".csv" });
      // fileSaver.saveAs(blob, "allCandidates.csv");
      Swal.fire({
        text: "File will be  mailed shortly to registered email Id (ETA 2 Minutes)",
      });
    } catch (err) {
      console.log(err);
    }
  };

  // const mainTable = [];
  // for (let i = 0; i < 20; i++) {
  //   mainTable.push({
  //     key: i + 1,
  //     candidate: i % 2 === 0 ? "Ramesh" : i % 3 === 0 ? "Suresh" : "Rajesh",
  //     mobile: "8885558888",
  //     education: i % 2 === 0 ? "Graduacte" : i % 3 === 0 ? "HSC" : "SSC",
  //     role: i % 2 === 0 ? "Full Stack" : i % 3 === 0 ? "Carpenter" : "Android Developer",
  //     state: i % 2 === 0 ? "Maharashtra" : i % 3 === 0 ? "Delhi" : "Gujrat",
  //     district: i % 2 === 0 ? "Mumbai" : i % 3 === 0 ? "Delhi" : "Surat",
  //     skills: "Cartpenter, welding",
  //     score: `80`,
  //     status: i % 2 === 0 ? "true" : i % 3 === 0 ? "false" : "",
  //   });
  // }
  const [downloadingModal, setDownloadingModal] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [admindata, Setadmindata] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedCSVData, setSelectedCSVData] = useState([]);
  const [tablerow, setTablerow] = useState([]);
  const [fileName, setFileName] = useState("");
  const [paginationState, setPaginationState] = useState({
    page: 1,
    dataSize: "",
  });
  const [show, setShow] = useState(false);
  const fetchCandidates = async () => {
    setIsLoading(true);
    console.log("idss::", orgId, jobId);
    let payload = {
      cp_id: cpId,
      orgid: orgId,
      jobid: jobId,
      limit: pageSize,
      offset: paginationState.page - 1,
      job_type: tableshow === 3 ? "Internship" : "",
    };
    await axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/details`,
        {
          // params: tableshow === 3 ? { ...payload, job_type: "Internship" } : payload,
          params: payload,
        }
      )
      .then((res) => {
        console.log(res.data["js_data"], "js_data");
        sessionStorage.setItem("dow_id", res.data.download_id);
        setSearchData(
          res.data["js_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" || ele.email === null || ele.email === "" ? "" : ele.email,
            gender:
              ele.gender === "nan" || ele.gender === "" || ele.gender === null ? "" : ele.gender,
            state: ele.state === "nan" || ele.state === "" || ele.state === null ? "" : ele.state,
            district:
              ele.district === "nan" || ele.district === "" || ele.district === null
                ? ""
                : ele.district,
            taluka:
              ele.taluka === "nan" || ele.taluka === "" || ele.taluka === null ? "" : ele.taluka,
            highest_education:
              ele.highest_education === "nan" ||
              ele.highest_education === "" ||
              ele.highest_education === null
                ? ""
                : ele.highest_education,
            degree:
              ele.degree === "nan" || ele.degree === "" || ele.degree === null ? "" : ele.degree,
            stream:
              ele.stream === "nan" || ele.stream === "" || ele.stream === null ? "" : ele.stream,
            experience:
              ele.experience === "nan" || ele.experience === "" || ele.experience === null
                ? ""
                : ele.experience,
            current_salary:
              ele.current_salary === "nan" ||
              ele.current_salary === "" ||
              ele.current_salary === null
                ? ""
                : ele.current_salary,
            desired_salary:
              ele.desired_salary === "nan" ||
              ele.desired_salary === "" ||
              ele.desired_salary === null
                ? ""
                : ele.desired_salary,
            job_role:
              ele.job_role === "nan" || ele.job_role === "" || ele.job_role === null
                ? ""
                : ele.job_role,
            industry:
              ele.industry === "nan" || ele.industry === "" || ele.industry === null
                ? ""
                : ele.industry,
            marital_status:
              ele.marital_status === "nan" ||
              ele.marital_status === "" ||
              ele.marital_status === null
                ? ""
                : ele.marital_status,
            skills:
              ele.skills === "nan" || ele.skills === "" || ele.skills === null ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv:
              ele.resume_cv === "nan" || ele.resume_cv === "" || ele.resume_cv === null
                ? ""
                : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages:
              ele.languages === "nan" || ele.languages === "" || ele.languages === null
                ? ""
                : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback:
              ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                ? ""
                : ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.candidate_status ? ele.candidate_status : "Bot yet to engage",
            display_comment:
              ele.display_comment === "" ||
              ele.display_comment === "nan" ||
              ele.display_comment === null
                ? ""
                : ele.display_comment,
          }))
        );
        Setadmindata(
          res.data["js_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education: ele.highest_education === "nan" ? "" : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback: ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.candidate_status ? ele.candidate_status : "Bot yet to engage",
            display_comment: ele.display_comment,
          }))
        );
        setPaginationState({ ...paginationState, dataSize: res.data["count"] });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err candidate", err.response);
      });
  };
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
    filterData(admindata, newSelectedRowKeys);
    setTablerow(selectedRows);
    // setShortlistObj(
    //   selectedRows.reduce(
    //     (obj, item) =>
    //       Object.assign(obj, { [item.key]: item.score === undefined ? 0 : item.score }),
    //     {}
    //   )
    // );
  };
  const filterData = (data, keyId) => {
    const newData = data.filter((item, id) => {
      // return item.key!==keyId
      // i => ids.includes( i.empid )
      return keyId.includes(item.key);
    });
    console.log(newData);
    setSelectedCSVData(newData);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
  };
  const handlePageSizeChange = (current, size) => {
    console.log("Selected page size:", size);
    setPageSize(size);
  };
  console.log("selected data", selectedCSVData);

  const getFileName = () => {
    let d = new Date();
    let dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    console.log("getCurrentDate : ", dformat);
    const file = "mis_candidate_data_" + dformat + ".csv";
    setFileName(file);
    // return "mis_data_" + dformat + ".txt";
  };

  const handleFormChange12 = (event, index, state, setState) => {
    let data = [...state];
    console.log(index);
    console.log(event);
    data[index]["isExportable"] = !data[index]["isExportable"];
    // data[index][event] = event.value;
    setState(data);
  };

  const bulkUploadfunc = () => {
    setLoading(true);
    Swal.fire({
      //icon: "success",
      title: "Uploading",
      text: "File upload is in progress",
      showConfirmButton: false,
      timer: 3000,
    });
    let formData = new FormData();
    formData.append("jobseeker_file", CSVFile);
    formData.append("datasource", cpId);
    formData.append("job_type", tableshow === 3 ? "Internship" : "");
    // formData.append("jobid", objectOfLinks.jobId);
    // formData.append("orgid", objectOfLinks.orgid);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/upload`,
        formData
      )
      .then((res) => {
        setLoading(false);
        if (res.status === 201) {
          /*
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "File Uploaded successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          */

          Swal.fire({
            icon: "success",
            // title: "Success",
            // text: "File Uploaded successfully",
            title: "File Uploaded Successfully",
            html:
              "Successfully Uploaded: " +
              `${res.data["Success"]}` +
              "<br/>" +
              "Failed In Uploading: " +
              `${res.data["On Hold"]}` +
              "<br/>" +
              "Data Already Existing With Us: " +
              `${res.data["Duplicates"]}`,
            showConfirmButton: res?.data?.link !== "" ? true : false,
            confirmButtonText: "Data Quality Issue",
            // timer: 3000,
          }).then((result) => {
            if (result.isConfirmed) {
              if (res?.data?.link !== "") {
                //var blob = new Blob([res.data.link], { type: ".csv" });
                //fileSaver.saveAs(blob, "download.csv");
                const link = document.createElement("a");
                link.href = res?.data?.link;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                console.log("error");
              }
            }
          });

          // setactionModal2(false);
          setUploadModal(false);
          setUploadOption(false);
          // setShowSnackbar(false);
          // UploadedList();
          // setUploadModal(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: err.response.data["Developer Message"]
            ? err.response.data["Developer Message"]
            : "Oops...",
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  console.log(filteroff, "BBB");

  const fetchFilteredCandidates = async () => {
    setIsLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/filter`,
        {
          jobid: jobId,
          cpid: cpId,
          date: filteroff ? [] : datefilter ? datefilter : [],
          state: filteroff ? "" : statefilter ? statefilter : "",
          district: filteroff ? "" : districtfilter ? districtfilter : "",
          status: filteroff ? "" : jffilter ? jffilter : "",
          gender: filteroff ? "" : rolefilter ? rolefilter : "",
          // age: filteroff ? "" : boardingfilter ? boardingfilter : "",
          age: "",
          limit: pageSize,
          offset: paginationState.page - 1,
          job_type: tableshow === 3 ? "Internship" : "",
        }
      )
      .then((res) => {
        console.log("res", res);
        sessionStorage.setItem("dow_id", res.data.download_id);
        setIsLoading(false);
        setSearchData(
          res.data["filter_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" || ele.email === null || ele.email === "" ? "" : ele.email,
            gender:
              ele.gender === "nan" || ele.gender === "" || ele.gender === null ? "" : ele.gender,
            state: ele.state === "nan" || ele.state === "" || ele.state === null ? "" : ele.state,
            district:
              ele.district === "nan" || ele.district === "" || ele.district === null
                ? ""
                : ele.district,
            taluka:
              ele.taluka === "nan" || ele.taluka === "" || ele.taluka === null ? "" : ele.taluka,
            highest_education:
              ele.highest_education === "nan" ||
              ele.highest_education === "" ||
              ele.highest_education === null
                ? ""
                : ele.highest_education,
            degree:
              ele.degree === "nan" || ele.degree === "" || ele.degree === null ? "" : ele.degree,
            stream:
              ele.stream === "nan" || ele.stream === "" || ele.stream === null ? "" : ele.stream,
            experience:
              ele.experience === "nan" || ele.experience === "" || ele.experience === null
                ? ""
                : ele.experience,
            current_salary:
              ele.current_salary === "nan" ||
              ele.current_salary === "" ||
              ele.current_salary === null
                ? ""
                : ele.current_salary,
            desired_salary:
              ele.desired_salary === "nan" ||
              ele.desired_salary === "" ||
              ele.desired_salary === null
                ? ""
                : ele.desired_salary,
            job_role:
              ele.job_role === "nan" || ele.job_role === "" || ele.job_role === null
                ? ""
                : ele.job_role,
            industry:
              ele.industry === "nan" || ele.industry === "" || ele.industry === null
                ? ""
                : ele.industry,
            marital_status:
              ele.marital_status === "nan" ||
              ele.marital_status === "" ||
              ele.marital_status === null
                ? ""
                : ele.marital_status,
            skills:
              ele.skills === "nan" || ele.skills === "" || ele.skills === null ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv:
              ele.resume_cv === "nan" || ele.resume_cv === "" || ele.resume_cv === null
                ? ""
                : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages:
              ele.languages === "nan" || ele.languages === "" || ele.languages === null
                ? ""
                : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback:
              ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                ? ""
                : ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.candidate_status ? ele.candidate_status : "Bot yet to engage",
            display_comment:
              ele.display_comment === "nan" ||
              ele.display_comment === "" ||
              ele.display_comment === null
                ? ""
                : ele.display_comment,
          }))
        );
        Setadmindata(
          res.data["filter_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education: ele.highest_education === "nan" ? "" : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback:
              ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                ? ""
                : ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.candidate_status ? ele.candidate_status : "Bot yet to engage",
            display_comment:
              ele.display_comment === "nan" ||
              ele.display_comment === "" ||
              ele.display_comment === null
                ? ""
                : ele.display_comment,
          }))
        );
        setPaginationState({ ...paginationState, dataSize: res.data["count"] });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    handleFetchjob();
  }, [orgId]);
  useEffect(() => {
    // handleFetchorg();
    // fetchCandidates();
    handleKPIs();
  }, []);
  useEffect(() => {
    jobId !== "" && handleKPIs();
  }, [jobId]);
  useEffect(() => {
    // (jobId !== "" || orgId !== "") && fetchCandidates();
    fetchCandidates();
  }, [jobId, orgId]);

  useEffect(() => {
    // fetchFilteredCandidates();
    datefilter.length === 0 &&
      statefilter === "" &&
      districtfilter === "" &&
      jffilter === "" &&
      rolefilter === "" &&
      name === "" &&
      !filteroff &&
      fetchCandidates();
  }, [paginationState.page, pageSize]);

  useEffect(() => {
    // if (name === "") {
    //   fetchCandidates();
    // } else {
    //   const DebounceFunc = setTimeout(() => {
    //     handleDynamicSearch();
    //   }, 1000);

    //   return () => clearTimeout(DebounceFunc);
    // }
    if (name !== "") {
      const DebounceFunc = setTimeout(() => {
        handleDynamicSearch();
      }, 1000);

      return () => clearTimeout(DebounceFunc);
    } else {
      fetchCandidates();
    }
  }, [name]);

  useEffect(() => {
    // datefilter.length === 0 &&
    //   statefilter === "" &&
    //   districtfilter === "" &&
    //   jffilter === "" &&
    //   rolefilter === "" &&
    //   name !== "" &&
    //   handleDynamicSearch();

    if (
      datefilter.length === 0 &&
      statefilter === "" &&
      districtfilter === "" &&
      jffilter === "" &&
      rolefilter === "" &&
      name !== ""
    ) {
      handleDynamicSearch();
    } else if (
      datefilter.length !== 0 &&
      statefilter !== "" &&
      districtfilter !== "" &&
      jffilter !== "" &&
      rolefilter !== "" &&
      name !== ""
    ) {
      handleDynamicSearch();
    } else if (name !== "") {
      handleDynamicSearch();
    }
    // else {
    //   fetchFilteredCandidates();
    // }
  }, [paginationState.page, pageSize]);
  useEffect(() => {
    (datefilter.length !== 0 ||
      statefilter !== "" ||
      districtfilter !== "" ||
      jffilter !== "" ||
      rolefilter !== "") &&
      name === "" &&
      fetchFilteredCandidates();
    // showFilter === false && fetchFilteredCandidates();
  }, [paginationState.page, pageSize, filteroff]);

  const resetfunc = () => {
    setFilteroff(true);
    setBoardingfilter([18, 45]);
    setRolefilter("");
    setStatefilter("");
    setDistrictfilter("");
    setJffilter("");
    setDatefilter([]);
    fetchCandidates();
  };

  const setFunc = () => {
    setFilteroff(false);
  };

  // useEffect(() => {
  //   (datefilter.length !== 0 ||
  //     statefilter !== "" ||
  //     districtfilter !== "" ||
  //     jffilter !== "" ||
  //     rolefilter !== "") &&
  //     fetchFilteredCandidates();
  // }, [filteroff]);

  return (
    <>
      <DashboardLayout>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            <img
              src={imga6}
              height={"30px"}
              style={{ marginTop: "8px", marginBottom: "8px" }}
              alt=""
            />

            <Box sx={{ m: 1 }}>
              <ST3 variant="body1">Candidates for</ST3>
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <Box sx={{ m: 1, minWidth: "230px" }}>
                <ST4 variant="body1">Select Organization Name</ST4>

                <Select
                  isClearable
                  options={orgList}
                  value={orgList.filter((ele) => orgId === ele.value)}
                  onChange={(e) => (setJobId(""), setOrgId(e ? e.value : ""))}
                  styles={stylesDD}
                />
              </Box>

              <Box sx={{ m: 1, minWidth: "230px" }}>
                <ST4 variant="body1">Select Job Role</ST4>

                <Select
                  isClearable
                  options={jobList}
                  value={jobList?.filter((ele) => jobId === ele.value)}
                  onChange={(e) => setJobId(e ? e.value : "")}
                  styles={stylesDD}
                />
              </Box>
            </Box>
          </Box>

          <SoftBox
            sx={{
              height: "34px",
              backgroundColor: "#FFF",
              borderRadius: "2px",
              cursor: "pointer",
              p: 1,
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="40px"
            onClick={() => (handleFetchorg(), handleKPIs(), resetfunc())}
          >
            <SoftBox>
              <img src={refreshBtn} />
            </SoftBox>
          </SoftBox>
        </Box>
        <br />

        <MuiGrid container spacing={2}>
          <MuiGrid item lg={2.4} md={3} sm={6} xs={12}>
            <Box
              sx={{
                maxWidth: "100%",
                minHeight: "100px",
                background: "#FAEDCD",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: "22px",
                boxShadow: "0px 4px 10px 0px #0000001A",
              }}
            >
              {fetching ? (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" height={"24px"} width={"24px"} alt="" />

                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      sx={{ height: "18px", width: "100px", ml: 1 }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ height: "18px", width: "50px", mt: 1 }}
                  />
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img src={imga1} height={"24px"} alt="" />

                    <ST1 variant="body1">
                      &nbsp;Jobs Assigned <img src={info} height={"15px"} width={"15px"} />
                    </ST1>
                  </Box>

                  <ST2 variant="body1">{KPIObj.job_assigned_count}</ST2>
                </>
              )}
            </Box>
          </MuiGrid>

          <MuiGrid item lg={2.4} md={3} sm={6} xs={12}>
            <Box
              sx={{
                maxWidth: "100%",
                minHeight: "100px",
                background: "#E7C6FF59",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: "22px",
                boxShadow: "0px 4px 10px 0px #0000001A",
              }}
            >
              {fetching ? (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" height={"24px"} width={"24px"} alt="" />

                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      sx={{ height: "18px", width: "100px", ml: 1 }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ height: "18px", width: "50px", mt: 1 }}
                  />
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img src={imga2} height={"24px"} alt="" />

                    <ST1 variant="body1">
                      &nbsp;Jobs Accepted <img src={info} height={"15px"} width={"15px"} />
                    </ST1>
                  </Box>

                  <ST2 variant="body1">{KPIObj.job_accepted_count}</ST2>
                </>
              )}
            </Box>
          </MuiGrid>

          <MuiGrid item lg={2.4} md={3} sm={6} xs={12}>
            <Box
              sx={{
                maxWidth: "100%",
                minHeight: "100px",
                background: "#D8E2DC4D",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: "22px",
                boxShadow: "0px 4px 10px 0px #0000001A",
              }}
            >
              {fetching ? (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" height={"24px"} width={"24px"} alt="" />

                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      sx={{ height: "18px", width: "100px", ml: 1 }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ height: "18px", width: "100px", mt: 1 }}
                  />
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img src={imga3} height={"24px"} alt="" />

                    <ST1 variant="body1">
                      &nbsp;Candidates Shared <img src={info} height={"15px"} width={"15px"} />
                    </ST1>
                  </Box>

                  <ST2 variant="body1">{KPIObj.candidate_upload_count}</ST2>
                </>
              )}
            </Box>
          </MuiGrid>

          <MuiGrid item lg={2.4} md={3} sm={6} xs={12}>
            <Box
              sx={{
                maxWidth: "100%",
                minHeight: "100px",
                background: "#E4FDE180",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: "22px",
                boxShadow: "0px 4px 10px 0px #0000001A",
              }}
            >
              {fetching ? (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" height={"24px"} width={"24px"} alt="" />

                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      sx={{ height: "18px", width: "90px", ml: 1 }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ height: "18px", width: "50px", mt: 1 }}
                  />
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img src={imga4} height={"24px"} alt="" />

                    <ST1 variant="body1">
                      &nbsp;Total Placed <img src={info} height={"15px"} width={"15px"} />
                    </ST1>
                  </Box>

                  <ST2 variant="body1">{KPIObj.placed_count}</ST2>
                </>
              )}
            </Box>
          </MuiGrid>

          <MuiGrid item lg={2.4} md={3} sm={6} xs={12}>
            <Box
              sx={{
                maxWidth: "100%",
                minHeight: "100px",
                background: "#FFDAB933",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: "22px",
                boxShadow: "0px 4px 10px 0px #0000001A",
              }}
            >
              {fetching ? (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" height={"24px"} width={"24px"} alt="" />

                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      sx={{ height: "18px", width: "100px", ml: 1 }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ height: "18px", width: "100px", mt: 1 }}
                  />
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img src={imga5} height={"24px"} alt="" />

                    <ST1 variant="body1">
                      &nbsp;Expected Cost <img src={info} height={"15px"} width={"15px"} />
                    </ST1>
                  </Box>

                  <ST2 variant="body1">{KPIObj.expectedCost}</ST2>
                </>
              )}
            </Box>
          </MuiGrid>

          {/* <MuiGrid item lg={2} md={3} sm={6} xs={12}>
            <Box
              sx={{
                maxWidth: "100%",
                minHeight: "100px",
                background: "#FFB7FF33",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: "22px",
                boxShadow: "0px 4px 10px 0px #0000001A",
              }}
            >
              {fetching ? (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" height={"24px"} width={"24px"} alt="" />

                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      sx={{ height: "18px", width: "90px", ml: 1 }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ height: "18px", width: "40px", mt: 1 }}
                  />
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img src={imga5} height={"24px"} alt="" />

                    <ST1 variant="body1">
                      &nbsp;Actual Cost <img src={info} height={"15px"} width={"15px"} />
                    </ST1>
                  </Box>

                  <ST2 variant="body1">{KPIObj.actualCost}</ST2>
                </>
              )}
            </Box>
          </MuiGrid> */}
        </MuiGrid>
        <br />
        <hr />

        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            mb: 2,
          }}
        >
          <SoftBox
            sx={{
              border: "1px solid #000",
              borderRadius: "5px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: "0px",
              width: "125px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 0 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(0);
              setOrgId("");
              setJobId("");
            }}
          >
            <SoftTypography
              sx={
                tableshow === 0
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#000",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              All Jobs
            </SoftTypography>
          </SoftBox>

          <SoftBox
            sx={{
              borderTop: "1px solid #000",
              borderBottom: "1px solid #000",
              width: "175px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 1 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(1);
            }}
          >
            <SoftTypography
              sx={
                tableshow === 1
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Self-Employment
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              borderTop: "1px solid #000",
              borderBottom: "1px solid #000",
              borderLeft: "1px solid #000",
              width: "175px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 2 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(2);
            }}
          >
            <SoftTypography
              sx={
                tableshow === 2
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Skilling
            </SoftTypography>
          </SoftBox>

          <SoftBox
            sx={{
              border: "1px solid #000",
              borderRadius: "5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              width: "125px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 3 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(3);
            }}
          >
            <SoftTypography
              sx={
                tableshow === 3
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Internship
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ m: 1, minWidth: "300px", display: "flex", gap: "20px" }}>
            <SoftInput
              isClearable
              id="search-bar"
              className="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              placeholder="Search..."
            />
            {/*
            <Button
              onClick={() => (name !== "" ? handleDynamicSearch() : fetchCandidates())}
              sx={{
                m: 1,
                p: 2,
                width: !matchsm ? "110px" : "100%",
                height: "34px",
                background: "#3B5092",
                textTransform: "none",
                "&:hover": {
                  background: "#3B5092",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#FFFFFF",
                }}
              >
                Search
              </Typography>
            </Button>
            <Button
              onClick={() => {
                setName("");
                fetchCandidates();
              }}
              sx={{
                visibility: name ? "visible" : "hidden",
                m: 1,
                p: 2,
                width: !matchsm ? "110px" : "100%",
                height: "34px",
                background: "#3B5092",
                textTransform: "none",
                "&:hover": {
                  background: "#3B5092",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#FFFFFF",
                }}
              >
                Reset
              </Typography>
            </Button>
           */}
          </Box>

          <Box sx={{ m: 1, display: "flex", justifyContent: "space-between" }}>
            <Tooltip
              key="1"
              title={tablerow.length === 0 ? "Download All" : "Download"}
              placement="top"
            >
              <SoftBox
                sx={{
                  height: "33px",
                  backgroundColor: "#000000",
                  borderRadius: "2px",
                  cursor: "pointer",
                  mr: "16px",
                }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                width="40px"
                onClick={() => {
                  handleClick();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="46"
                  height="34"
                  viewBox="0 0 46 34"
                  fill="none"
                >
                  <rect width="45.8992" height="33.0097" rx="5" fill="#111727" />
                  <path
                    d="M20.0547 20.1191L22.9438 23.0082L25.8328 20.1191"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22.9531 16.5098V23.0102"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29.3651 20.9074C29.9931 20.4658 30.464 19.8357 30.7095 19.1084C30.955 18.381 30.9624 17.5944 30.7305 16.8626C30.4986 16.1308 30.0396 15.4919 29.4201 15.0387C28.8005 14.5854 28.0526 14.3414 27.285 14.342H26.3749C26.1577 13.4954 25.7513 12.7091 25.1862 12.0424C24.6211 11.3756 23.9121 10.8457 23.1126 10.4926C22.3131 10.1395 21.4439 9.97232 20.5705 10.0037C19.697 10.0351 18.8421 10.2643 18.07 10.6739C17.2979 11.0836 16.6288 11.663 16.1131 12.3687C15.5974 13.0743 15.2485 13.8877 15.0926 14.7477C14.9368 15.6078 14.978 16.4919 15.2133 17.3337C15.4486 18.1754 15.8718 18.9528 16.451 19.6073"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SoftBox>
            </Tooltip>

            <Tooltip key="1" title="Filter" placement="top">
              <SoftBox
                sx={{
                  height: "33px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "2px",
                  cursor: "pointer",
                  mr: "16px",
                }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                width="40px"
                onClick={() => setShowFilter(true)}
              >
                <SoftBox>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="34"
                    viewBox="0 0 39 37"
                    fill="none"
                  >
                    <rect width="38.8889" height="37" rx="2" fill="white" />
                    <path
                      d="M28.8889 10H10L17.5556 18.9344V25.1111L21.3333 27V18.9344L28.8889 10Z"
                      stroke="#A4A4A4"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SoftBox>
              </SoftBox>
            </Tooltip>

            {sessionStorage.getItem("cp_type") !== "Vakrangee" && (
              <Tooltip key="2" title="Bulk upload candidates" placement="top">
                <SoftBox
                  sx={{
                    height: "33px",
                    backgroundColor: "#000000",
                    borderRadius: "2px",
                    cursor: "pointer",
                    mr: "16px",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  width="40px"
                  onClick={() => setUploadModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <g fill="none">
                      <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                      <path
                        fill="#fff"
                        d="M8 9v2H5v9h14v-9h-3V9h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3Zm4.884-6.531l3.359 3.358a1 1 0 1 1-1.415 1.415L13 5.413V15a1 1 0 1 1-2 0V5.413L9.172 7.242a1 1 0 1 1-1.415-1.415l3.36-3.358a1.25 1.25 0 0 1 1.767 0Z"
                      />
                    </g>
                  </svg>
                </SoftBox>
              </Tooltip>
            )}
          </Box>
        </Box>

        <Grid container>
          <SoftBox width="100%" height="auto" mt={0}>
            <SoftBox mb={3}>
              <Grid container>
                <Grid container item xs={12} lg={12}>
                  <SoftBox
                    alignItems="flex-start"
                    position="relative"
                    borderRadius="10px"
                    width="100%"
                  >
                    {tableshow === 0 && (
                      <Table
                        loading={isLoading}
                        rowSelection={rowSelection}
                        columns={colName}
                        // dataSource={searchData?.filter((ele) => {
                        //   return name?.toLocaleLowerCase() === ""
                        //     ? ele
                        //     : ele.candidate
                        //         ?.toLocaleLowerCase()
                        //         .includes(name.toLocaleLowerCase()) ||
                        //       name.toLocaleLowerCase() === ""
                        //     ? ele
                        //     : String(ele.mobile)
                        //         .toLocaleLowerCase()
                        //         .includes(name.toLocaleLowerCase());
                        // })}
                        dataSource={searchData}
                        scroll={{ x: 2600, y: 400 }}
                        // pagination={{
                        //   pageSizeOptions: ["10", "20", "50", "100", "500"],
                        //   showSizeChanger: true,
                        // }}
                        pagination={{
                          // defaultPageSize: ,
                          // position: ["none", "bottomCenter"],
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          total: paginationState.dataSize,
                          showSizeChanger: true,
                          // onShowSizeChange: { onShowSizeChange },
                          onShowSizeChange: handlePageSizeChange,
                          current: paginationState.page,
                          onChange: (page, pageSize) =>
                            setPaginationState({ ...paginationState, page: page }),
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                      />
                    )}

                    {tableshow === 1 && (
                      <Table
                        loading={isLoading}
                        columns={colName1}
                        dataSource={table1?.filter((ele) => {
                          return name?.toLocaleLowerCase() === ""
                            ? ele
                            : ele.candidate
                                ?.toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase()) ||
                              name.toLocaleLowerCase() === ""
                            ? ele
                            : String(ele.mobile)
                                .toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase());
                        })}
                        pagination={{
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                        scroll={{ x: 1800, y: 400 }}
                      />
                    )}

                    {tableshow === 2 && (
                      <Table
                        loading={isLoading}
                        columns={colName1}
                        dataSource={table2?.filter((ele) => {
                          return name?.toLocaleLowerCase() === ""
                            ? ele
                            : ele.candidate
                                ?.toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase()) ||
                              name.toLocaleLowerCase() === ""
                            ? ele
                            : String(ele.mobile)
                                .toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase());
                        })}
                        pagination={{
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                        scroll={{ x: 1800, y: 400 }}
                      />
                    )}
                    {tableshow === 3 && (
                      <Table
                        loading={isLoading}
                        rowSelection={rowSelection}
                        columns={colName3}
                        // dataSource={searchData?.filter((ele) => {
                        //   return name?.toLocaleLowerCase() === ""
                        //     ? ele
                        //     : ele.candidate
                        //         ?.toLocaleLowerCase()
                        //         .includes(name.toLocaleLowerCase()) ||
                        //       name.toLocaleLowerCase() === ""
                        //     ? ele
                        //     : String(ele.mobile)
                        //         .toLocaleLowerCase()
                        //         .includes(name.toLocaleLowerCase());
                        // })}
                        dataSource={searchData}
                        scroll={{ x: 2600, y: 400 }}
                        // pagination={{
                        //   pageSizeOptions: ["10", "20", "50", "100", "500"],
                        //   showSizeChanger: true,
                        // }}
                        pagination={{
                          // defaultPageSize: ,
                          // position: ["none", "bottomCenter"],
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          total: paginationState.dataSize,
                          showSizeChanger: true,
                          // onShowSizeChange: { onShowSizeChange },
                          onShowSizeChange: handlePageSizeChange,
                          current: paginationState.page,
                          onChange: (page, pageSize) =>
                            setPaginationState({ ...paginationState, page: page }),
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                      />
                    )}
                  </SoftBox>
                </Grid>
              </Grid>
            </SoftBox>
          </SoftBox>
        </Grid>
      </DashboardLayout>

      <SoftSnackbar
        color="success"
        icon="check"
        title="Link copied successfully"
        content={copiedLink}
        // dateTime="11 mins ago"
        open={showSnackbar}
        autoHideDuration={4000}
        close={toggleSnackbar}
      />

      {/* modal for export */}
      <Modal
        show={uploadModal}
        onHide={() => {
          setUploadModal(false);
          setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV"></p>

              <IconButton onClick={() => (setUploadModal(false), setUploadOption(false))}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                // className="HeaderCSV"
                style={{ fontSize: "16px", fontWeight: 600, color: "#000" }}
              >
                Upload
              </p>

              <p
                // className="HeaderCSV"
                style={{
                  fontSize: "14px",
                  fontWeight: "small",
                  lineHeight: "19px",
                  color: "#000",
                  marginBottom: "8px",
                }}
              >
                Please download the template file and reupload it with candidate details.
              </p>
              <SoftBox
                onClick={() => {
                  setInstructionModal(true);
                  setUploadModal(false);
                  // setShowSnackbar(false);
                }}
                style={{
                  fontSize: "12px",
                  fontWeight: "small",
                  // lineHeight: "19px",
                  color: "#3B5092",
                  textDecorationLine: "underline",
                  cursor: "pointer",
                }}
              >
                Read Guidelines
              </SoftBox>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <Link to="/Data-Upload-Template.xlsx" target="_blank" download>
                  <button className="download-btn">
                    <span className="download-btn-Text">Download Template</span>
                  </button>
                </Link>
                {/* <div> */}

                {uploadedOption ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <input
                      className="form-control"
                      type="file"
                      //accept=".pdf, .doc, .docx, .png, .jpg, .jpeg"
                      // accept="image/png, image/jpeg"
                      // onChange={handleFileUpload}
                      onChange={(e) => {
                        // const file = e.target.files[0],
                        console.log("resumefile ", e.target.files[0]),
                          setCSVFile(e.target.files[0]);
                      }}
                    />
                    <button className="template-btn" onClick={() => bulkUploadfunc()}>
                      <span className="template-btn-Text">Upload Template</span>
                    </button>
                  </div>
                ) : (
                  <button className="template-btn" onClick={() => setUploadOption(true)}>
                    <span className="template-btn-Text">Upload Template</span>
                  </button>
                )}
                {/* <input
                    id="imgupload"
                    style={{ display: "none" }}
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    // accept="image/png, image/jpeg"
                    // onChange={handleFileUpload}
                    onChange={(e) => {
                      // const file = e.target.files[0],
                      console.log("resumefile ", e.target.files[0]), setCSVFile(e.target.files[0]);
                    }}
                  /> */}
                {/* </div> */}
              </Box>

              <p
                // className="HeaderCSV"
                style={{ fontSize: "14px", fontWeight: 500, color: "#000", marginTop: "12px" }}
              >
                or
              </p>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: !matchsm ? "row" : "column",
                  justifyContent: "space-between",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "94px",
                      height: "94px",
                      background: "lightgrey",
                      marginBottom: "5px",
                      marginLeft: !matchsm ? "10px" : "80px",
                    }}
                  >
                    <img
                      src={KPIObj.qrLink !== "" ? KPIObj.qrLink : noDataImg}
                      width="94px"
                      height="94px"
                    />
                  </div>
                  <a href={KPIObj.qrLink} target="_blank" rel="noreferrer" download>
                    <button
                      style={{
                        marginLeft: !matchsm ? "0px" : "50px",
                        display: "inline-flex",
                        padding: " 5px 10px",
                        alignItems: "flex-start",
                        gap: "10px",
                        borderRadius: "2px",
                        background: "#d9d9d9",
                        height: "28px",
                      }}
                      // className="copy-btn"
                      // onClick={() => (
                      //   copy(KPIObj.qrLink),
                      //   setCopiedLink(KPIObj.qrLink),
                      //   toggleSnackbar()
                      // )}
                      // onClick={() => {
                      //   var blob = new Blob([KPIObj.qrLink], { type: ".jpg" });
                      //   fileSaver.saveAs(blob, "qrcode.jpg");
                      // }}
                    >
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                      >
                        <path
                          d="M14.5 6.25H7.75C6.92157 6.25 6.25 6.92157 6.25 7.75V14.5C6.25 15.3284 6.92157 16 7.75 16H14.5C15.3284 16 16 15.3284 16 14.5V7.75C16 6.92157 15.3284 6.25 14.5 6.25Z"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.25 10.75H2.5C2.10218 10.75 1.72064 10.592 1.43934 10.3107C1.15804 10.0294 1 9.64782 1 9.25V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H9.25C9.64782 1 10.0294 1.15804 10.3107 1.43934C10.592 1.72064 10.75 2.10218 10.75 2.5V3.25"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill="currentColor"
                          d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
                        />
                        <path
                          fill="currentColor"
                          d="M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"
                        />
                      </svg>
                      <span className="copy-btn-Text">Download QR</span>
                    </button>
                  </a>
                </Box>
                {!matchsm ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="117"
                    viewBox="0 0 2 117"
                    fill="none"
                  >
                    <path d="M1 0V117" stroke="#3B5092" />
                  </svg>
                ) : (
                  <hr style={{ color: "#344767" }} />
                )}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      // height: "94px",
                      // background: "lightgrey",
                      // padding: "5px 250px 5px 10px",
                      marginBottom: "5px",
                      // marginLeft: "10px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Form Link"
                      value={
                        // orgId && jobId
                        //   ? `https://mysbajobs.globalsapio.com/?cpid=${sessionStorage.getItem(
                        //       "register_id"
                        //     )}&orgid=${orgId}&jobId=${jobId}`
                        //   : `https://mysbajobs.globalsapio.com/?cpid=${sessionStorage.getItem(
                        //       "register_id"
                        //     )}`
                        KPIObj.formLink
                      }
                      style={{
                        display: "flex",
                        // justifyContent: "center",
                        alignItems: "flex-start",
                        border: "1px solid #3B5092",
                        width: "250px",
                        gap: "10px",
                        padding: "5px 10px 5px 10px",
                        fontSize: "12px",
                      }}
                    />
                  </div>

                  <a
                    href={
                      // orgId && jobId
                      //   ? `https://mysbajobs.globalsapio.com/?cpid=${sessionStorage.getItem(
                      //       "register_id"
                      //     )}&orgid=${orgId}&jobId=${jobId}`
                      //   : `https://mysbajobs.globalsapio.com/?cpid=${sessionStorage.getItem(
                      //       "register_id"
                      // )}`
                      KPIObj.formLink
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="copy-btn">
                      <span className="copy-btn-Text">Redirect to Form Link</span>
                    </button>
                  </a>
                  {/*
                <button
                  className="copy-btn"
                  style={{
                    // display: "inline-flex",
                    // justifyContent: "center",
                    width: "185px",
                    marginLeft: "40px",
                  }}
                  onClick={() => (
                    copy(
                      `https://mysbajobs.globalsapio.com/?cpid=${sessionStorage.getItem(
                        "register_id"
                      )}`
                    ),
                    setCopiedLink(
                      `https://mysbajobs.globalsapio.com/?cpid=${sessionStorage.getItem(
                        "register_id"
                      )}`
                    ),
                    toggleSnackbar()
                  )}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <path
                      d="M14.5 6.25H7.75C6.92157 6.25 6.25 6.92157 6.25 7.75V14.5C6.25 15.3284 6.92157 16 7.75 16H14.5C15.3284 16 16 15.3284 16 14.5V7.75C16 6.92157 15.3284 6.25 14.5 6.25Z"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.25 10.75H2.5C2.10218 10.75 1.72064 10.592 1.43934 10.3107C1.15804 10.0294 1 9.64782 1 9.25V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H9.25C9.64782 1 10.0294 1.15804 10.3107 1.43934C10.592 1.72064 10.75 2.10218 10.75 2.5V3.25"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="copy-btn-Text">Copy Form Link</span>
                </button>
                */}
                </Box>
              </Box>
            </Box>
          </SoftBox>

          {/* <Snackbar open={showSnackbar} autoHideDuration={4000} onClose={toggleSnackbar}>
            <Alert onClose={toggleSnackbar} severity="success" sx={{ width: "100%" }}>
              <p>Link copied successfully!</p>
              <p>{copiedLink}</p>
            </Alert>
          </Snackbar> */}
        </Modal.Body>
      </Modal>
      {/* modal for export */}

      <Modal
        show={resumeModal}
        onHide={() => {
          setResumeModal(false);
        }}
        centered
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <SoftBox sx={{ m: 0 }}>
          {console.log("rowdata for resume:", rowData)}
          <Modal.Body>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p className="HeaderCSV">Upload Resume </p>

              <button className="CloseBtn" onClick={() => setResumeModal(false)}>
                {/* <span>
                  <CloseIcon fontSize="small" />
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // justifyContent: "space-between",
                gap: "20px",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <input
                className="form-control"
                type="file"
                accept=".pdf, .doc, .docx, .png, .jpg, .jpeg"
                id="datasource"
                name="datasource"
                onChange={(e) => {
                  // const file = e.target.files[0],
                  console.log("resumefile ", e.target.files[0]),
                    setResumeFile(e ? e.target.files[0] : "");
                }}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "40px" }}>
              <button
                className="login-btn3"
                onClick={() => {
                  ResumeUploadFunc(rowData);
                }}
              >
                <span className="login-btn3-Text">Save</span>
              </button>
              <button className="login-btn4" onClick={() => setResumeModal(false)}>
                <span className="login-btn4-Text">Cancel</span>
              </button>
            </Box>
          </Modal.Body>
        </SoftBox>
      </Modal>

      {/* modal for instructions */}
      <Modal
        show={instructionModal}
        onHide={() => {
          setInstructionModal(false);
          setUploadModal(true);
        }}
        size="xl"
        centered
      >
        <Modal.Body>
          <SoftBox width="100%" display="flex" justifyContent="flex-end" alignItems="center">
            <IconButton
              onClick={() => {
                setInstructionModal(false);
                setUploadModal(true);
              }}
            >
              {/* <CloseIcon size="small" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </SoftBox>

          <SoftBox
            sx={{
              border: "1px solid #6c6c6c",
              borderRadius: "10px",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <SoftTypography fontSize="20px" fontWeight="medium" marginTop="12px">
              Guidelines:
            </SoftTypography>
            <SoftTypography fontSize="16px">
              While uploading the file (only excel files accepted), you have to make sure that the
              following fields with exact headers are present. The system will accept files only if
              the following headers are present. Even if there is no data in any of the headers, the
              data will still be accepted (try to put as much data as possible). Any data without
              mobile number (in 10 digits) will be rejected.
            </SoftTypography>
            <br />

            <SoftTypography fontStyle="12px" fontSize="16px">
              <ul>
                <li>First Name</li>
                <li>Date of Birth (DD-MM-YYYY)</li>
                <li>Mobile Number</li>
                <li>District</li>
                <li>State</li>
                <li>Highest Education</li>
              </ul>
            </SoftTypography>
            <br />
          </SoftBox>
          <SoftBox sx={{ marginTop: "10px" }}>
            <SoftTypography fontSize="16px" marginBottom="16px">
              The following section explains how all the data should be entered.
            </SoftTypography>
            <Table columns={colGuidelines} dataSource={GuideData} pagination={false} mb={2} />
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for instructions */}

      {/* modal for export */}
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p className="HeaderCSV">Select columns to export</p>

              <button className="CloseBtn" onClick={() => setShow(false)}>
                {/* <span>
                  <CloseIcon fontSize="small" />
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </Box>

            {colHeaders.map((ele, index) => (
              <>
                <ul className="UlCSV" key={index}>
                  <input
                    type="checkbox"
                    checked={ele.isExportable}
                    onChange={(event) =>
                      handleFormChange12(event, index, colHeaders, setColHeaders)
                    }
                  />
                  <span className="ListCSV">&nbsp;{ele.label}</span>
                </ul>
              </>
            ))}

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <button className="login-btn4" onClick={() => setShow(false)}>
                <span className="login-btn4-Text">Cancel</span>
              </button>

              <button className="login-btn3">
                {/* <SoftTypography display="flex" justifyContent="center" sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}>
                      Download
                    </SoftTypography> */}
                <CSVLink
                  data={tablerow.length === 0 ? searchData : tablerow}
                  //data={selectedCSVData}
                  filename={fileName}
                  headers={colHeaders.filter((ele) => ele.isExportable === true)}
                >
                  <span className="login-btn3-Text">Export</span>
                </CSVLink>
              </button>
            </Box>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for export */}

      {/* modal for uploading */}
      <Modal
        show={downloadingModal}
        onHide={() => {
          setDownloadingModal(false);
        }}
        centered
        size="sm"
        closeButton
        contentClassName="modal-height"
      >
        <Modal.Body>
          <SoftBox display="flex" justifyContent="center" alignItems="center">
            <SoftBox display="flex" flexDirection="column" gap={3}>
              <SoftTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
                Downloading.....
              </SoftTypography>
              <SoftTypography sx={{ fontSize: "14px", fontWeight: 400 }}>
                Please wait as we are downloading the file
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for uploading */}

      <Index
        open={showFilter}
        setOpen={setShowFilter}
        statefilter={statefilter}
        setStatefilter={setStatefilter}
        districtfilter={districtfilter}
        setDistrictfilter={setDistrictfilter}
        datefilter={datefilter}
        setDatefilter={setDatefilter}
        resetfunc={resetfunc}
        jffilter={jffilter}
        setJffilter={setJffilter}
        table={tableshow}
        educationfilter={educationfilter}
        setEducationfilter={setEducationfilter}
        rolefilter={rolefilter}
        setRolefilter={setRolefilter}
        degreefilter={degreefilter}
        setDegreefilter={setDegreefilter}
        boardingfilter={boardingfilter}
        setBoardingfilter={setBoardingfilter}
        setFunc={setFunc}
        fetchFilteredCandidates={fetchFilteredCandidates}
      />

      <SideDrawer
        openModal={openModal}
        setOpenModal={setOpenModal}
        veridetails={veridetails}
        setVeridetails={setVeridetails}
        timelineLoading={timelineLoading}
        setTimeLineLoading={setTimeLineLoading}
        time={time}
        setTime={setTime}
        candData={candData}
        setCandData={setCandData}
      />
    </>
  );
};

export default CandidatesList;
